// extracted by mini-css-extract-plugin
export default {"info":"Info_info__92EIk","infoTitle":"Info_infoTitle__rnVFn","infoName":"Info_infoName__QUvIh"};